import { useCountdown } from 'hooks/draw/useCountdown';
import { observer } from 'mobx-react-lite';
import styles from './DrawCounter.module.css';

interface DrawCountdownProps {
  headingText: string;
  targetDate: Date;
}

const DrawCountdown = observer(
  ({ headingText, targetDate }: DrawCountdownProps) => {
    const { paddedTimeLeft } = useCountdown(targetDate);

    const blocks = [
      { value: paddedTimeLeft.days, label: 'Days' },
      { value: paddedTimeLeft.hours, label: 'Hrs' },
      { value: paddedTimeLeft.minutes, label: 'Mins' },
      { value: paddedTimeLeft.seconds, label: 'Secs' },
    ];

    return (
      <div className={styles.container}>
        <span className={styles.heading}>{headingText}</span>
        <div className={styles.countdown}>
          {blocks.map((block, i) => (
            <div key={block.label} className={styles.blockWrapper}>
              {i > 0 && <span className={styles.separator}>:</span>}
              <div className={styles.timeBlock}>
                <div
                  className={`${styles.digits} aboutUsTypographyHeaderMedium`}
                >
                  {block.value.split('').map((digit, j) => (
                    <span key={j} className={styles.digit}>
                      {digit}
                    </span>
                  ))}
                </div>
                <span className={styles.label}>{block.label}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  },
);

export default DrawCountdown;
